import styled from "styled-components";
import { textTheme, colorTheme } from "../../theme";

type ListType = {
  available?: true;
};

export const DragDropContainer = styled.div`
  display: flex;
`;

export const ListContainer = styled.div<ListType>`
  width: 397px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  border: ${props =>
    props.available ? `1px solid ${colorTheme.divider}` : ""};
  box-shadow: ${props =>
    props.available ? "0px 4px 18px rgba(0, 0, 0, 0.06)" : ""};
  margin-left: ${props => (props.available ? "76px" : "")};
  padding-bottom: ${props => (props.available ? "18px" : "")};
`;

export const Header = styled.div<ListType>`
  height: 50px;
  display: ${props => (props.available ? "flex" : "")};
  justify-content: ${props => (props.available ? "space-between" : "")};
  align-items: ${props => (props.available ? "center" : "")};
  padding: ${props => (props.available ? "0px 18px" : "")};
`;

export const Title = styled.div`
  ${textTheme.subtitle2};
`;

export const SearchContainer = styled.div`
  position: relative;
`;

export const SearchIcon = styled.img`
  position: absolute;
  top: 6px;
  left: 5px;
`;

export const Searchbar = styled.input`
  ${textTheme.body2}
  height: 25px;
  width: 150px;
  border: 1px solid ${colorTheme.gray};
  border-radius: 4px;
  padding-left: 25px;
  &:focus {
    outline: none;
  }
`;

export const DraggableContainer = styled.div<ListType>`
  border-top: ${props =>
    props.available ? `1px solid ${colorTheme.divider}` : ""};
  position: ${props => (props.available ? "" : "relative")};
`;

export const PlaceHolderContainer = styled.div``;

export const PlaceHolder = styled.div`
  height: 60px;
  width: 397px;
  border: 1px solid ${colorTheme.gray};
  background-color: ${colorTheme.grayLightest};
  box-sizing: border-box;
  border-radius: 6px;
  margin-bottom: 10px;
`;

export const DraggableItemContainer = styled.div`
  position: absolute;
  top: 0;
`;

export const DraggableItem = styled.div<ListType>`
  ${textTheme.body2}
  display: flex;
  border-radius: 6px;
  padding-left: 6px;
  padding-right: 15px;
  box-sizing: border-box;
  height: 60px;
  width: 397px;
  justify-content: ${props => (props.available ? "" : "space-between")};
  align-items: ${props => (props.available ? "" : "center")};
  background-color: ${props => (props.available ? "" : `${colorTheme.white}`)};
  border: ${props =>
    props.available ? "" : `1px solid ${colorTheme.grayLightest}`};
  box-shadow: ${props =>
    props.available ? "" : "0px 4px 10px rgba(0, 0, 0, 0.08)"};
  margin-bottom: ${props => (props.available ? "" : "10px")};
`;

export const ColorBar = styled.div`
  width: 6px;
  height: 47px;
  margin: 6px 0px;
  border-radius: 2px 0px 0px 2px;
  background-color: ${props => props.color};
  box-sizing: border-box;
`;

export const Content = styled.div<ListType>`
  ${textTheme.body2}
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${props =>
    props.available ? `1px solid ${colorTheme.divider}` : ""};
  padding-left: 24px;
`;

export const Icon = styled.img`
  &:hover {
    cursor: pointer;
  }
`;
